<div class="container-fluid">
  <form class="theme-form mega-form" [formGroup]="bonusForm">
    <div
      class="p-2 d-flex align-items-center mb-3"
      [ngClass]="getTopAlertClass()"
      role="alert"
      *ngIf="shouldShowTopAlert()"
    >
      <i class="fa-solid fa-circle-info me-2"></i>
      <span class="d-block">
        {{ getTopAlertMessage() }}
      </span>
    </div>

    <div class="form-block" *ngIf="idRol !== 4">
      <div class="section-divider">
        <span class="form-block__title">Agente</span>
      </div>
      <div class="row g-3 mt-2">
        <div class="col-md-12">
          <label class="form-check-label field-label" for="userTypeSwitch">
            Selecciona un agente <span class="required-mark">*</span>
          </label>
          <ng-select
            [items]="isAgent ? allAgentsData : allPlayersData"
            bindLabel="label"
            bindValue="value"
            required
            formControlName="id_agente"
            class="mb-2"
            placeholder="Selecciona un agente"
            (scrollToEnd)="onScrollToEnd()"
            (search)="onSearch($event.term)"
            (clear)="onSearch('')"
            (open)="onSearch('')"
          ></ng-select>
          <div
            *ngIf="
              bonusForm.controls.id_agente.touched &&
              bonusForm.controls.id_agente.errors?.required
            "
            class="text-danger font-error mt-2"
          >
            Selecciona un {{ isAgent ? "agente" : "jugador" }}!.
          </div>
        </div>
      </div>
    </div>

    <div class="form-block">
      <div class="section-divider">
        <span class="form-block__title">Configuracion del bono</span>
      </div>

      <div class="row g-3 mt-2">
        <div class="col-md-6 mb-3">
          <div class="field-header">
            <label class="form-label field-label mb-0">
              Tipo de Bono <span class="required-mark">*</span>
            </label>
          </div>
          <ng-select
            [items]="allTypeBonusData"
            bindLabel="label"
            bindValue="value"
            formControlName="tipo_bono"
            class="mb-2"
            [placeholder]="getBonusTypePlaceholder()"
            [clearable]="false"
            [searchable]="true"
            [loading]="isLoadingBonusTypes"
            [readonly]="!canConfigureBonus() || isLoadingBonusTypes"
            (change)="onSelectChange($event)"
          ></ng-select>
          <div class="text-muted font-error mt-2" *ngIf="isLoadingBonusTypes">
            Cargando bonos asignados...
          </div>
          <div
            class="text-danger font-error mt-2"
            *ngIf="
              bonusForm.controls.tipo_bono!.touched &&
              bonusForm.controls.tipo_bono.errors?.required
            "
          >
            Selecciona un tipo de bono!.
          </div>
        </div>

        <div class="col-md-6">
          <div class="field-header">
            <label class="form-label field-label mb-0" for="validationCustom01">
              Monto recarga <span class="required-mark">*</span>
            </label>
          </div>
          <div class="input-group">
            <span class="input-group-text" id="inputGroupPrepend2">
              {{ id_country === 1 ? "$" : "S/." }}
            </span>
            <input
              class="form-control"
              id="validationCustom01"
              type="text"
              placeholder="0.00"
              required=""
              [attr.disabled]="!canConfigureBonus() ? true : null"
              (keypress)="onKeyPressSpecial($event)"
              (input)="onRechargeAmountChange($event)"
              formControlName="monto_recarga"
            />
          </div>
          @if (
            bonusForm.controls.monto_recarga!.touched &&
            bonusForm.controls.monto_recarga.errors?.required
          ) {
            <div class="text-danger font-error mt-2">
              Ingresa un valor para crear el bono.
            </div>
          }
        </div>
      </div>

      <div class="row g-3">
        <div class="col-md-6">
          <div class="field-header">
            <label class="form-label field-label mb-0" for="validationCustom03">
              Cantidad de Bonos <span class="required-mark">*</span>
            </label>
          </div>
          <div class="input-group">
            <input
              class="form-control"
              type="number"
              formControlName="fracciones"
              required=""
              step="1"
              [attr.disabled]="!canConfigureBonus() ? true : null"
              (input)="onInputChange($event)"
            />
          </div>
        </div>

        <div class="col-md-6">
          <div class="field-header field-header--with-badge">
            <label class="form-label field-label mb-0" for="validationCustom03">
              Monto por Bono
            </label>
            <span class="badge text-bg-light bonus-badge">Auto</span>
          </div>
          <div class="input-group">
            <span class="input-group-text" id="inputGroupPrepend2">{{
              id_country === 1 ? "$" : "S/."
            }}</span>
            <input
              class="form-control"
              type="text"
              placeholder="0.00"
              formControlName="monto"
              (keypress)="onKeyPressSpecial($event)"
              required
              [attr.disabled]="!canConfigureBonus() ? true : null"
              readonly
            />
          </div>
        </div>
      </div>
    </div>

    <div class="form-block">
      <div class="section-divider">
        <span class="form-block__title">Observaciones</span>
      </div>
      <div class="row g-3 mt-2">
        <div class="col-md-12 mb-3">
          <label class="form-label field-label" for="validationCustom04">
            Detalle <span class="optional-text">(opcional)</span>
          </label>
          <textarea
            class="form-control"
            formControlName="comentario"
            rows="4"
            [attr.disabled]="!canConfigureBonus() ? true : null"
            placeholder="Escribe una observación o referencia interna..."
          ></textarea>
          <div class="character-counter mt-2">
            {{ (bonusForm.get("comentario")?.value || "").length }} caracteres
          </div>
          @if (
            bonusForm.controls.comentario!.touched &&
            bonusForm.controls.comentario.errors?.required
          ) {
            <div class="text-danger font-error mt-2">
              Selecciona un comentario!.
            </div>
          }
        </div>
      </div>
    </div>

    <div class="text-end">
      <button class="btn btn-cancel me-2" type="button" (click)="closeModal()">
        Cancelar
      </button>
      @if (isLoadingButton) {
        <button class="btn btn-create" type="button" disabled>
          <i class="fas fa-ticket-alt fa-spin fa-xs me-1"></i>Creando Bono
        </button>
      } @else {
        <button
          type="button"
          class="btn btn-create"
          [disabled]="!isFormValid()"
          (click)="sendFormData()"
        >
          Crear
        </button>
      }
    </div>
  </form>
</div>
